<input
  type="date"
  class="hmm-input tw-w-full"
  aria-label="date"
  [value]="value"
  (change)="onChange($event)"
/>
